import React, { useEffect, useRef, useState } from "react";
import { Container, Grid, Typography, Paper} from "@mui/material";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { usePagination } from "Components/uiControls/Table/hooks";
import { searchHistoryIncidents, sendGenericExport } from "Redux/actions";
import { Table, SearchInput, Toolbar, Button } from "Components/uiControls";
import { FilterButton } from 'Components/Table';
import { TableButtons } from 'Components/uiControls/Table';
import { Pill } from 'Components';
import colors from 'Assets/sass/core/vars.scss';
import { HistoryTable } from "./components/table";
import { HistoryFilter } from "./components/filter";


export const History = () => {

  const [showSidePanel, setShowSidePanel] = useState(false)
  const [date, setDate] = useState()


  return (
    <Container maxWidth={false} className="container-view">
      <Paper elevation={0} style={{ padding: 24}}>
        <HistoryTable 
          date={date}
          showSidePanel={showSidePanel} 
          setShowSidePanel={setShowSidePanel}
        />
        <HistoryFilter 
          date={date}
          setDate={setDate}
          showSidePanel={showSidePanel} 
          setShowSidePanel={setShowSidePanel}
        />
      </Paper>
    </Container>
  );
};
